import { mergeStyleSets } from '@uifabric/merge-styles';
import { Depths } from '@uifabric/fluent-theme';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  root: {
    backgroundColor: theme.palette.neutralWhite,
    position: 'relative',
    width: '100%',
    zIndex: 5,
    selectors: {
      '.can-clear': {
        boxShadow: Depths.depth4,
      },
      '.can-clear .ms-SearchBox-clearButton .ms-Button-icon': {
        color: theme.palette.neutralDark,
        fontWeight: 600,
      },
      [layout.breakpoints.max.md]: {
        maxWidth: pxToRem(452),
      },
      [layout.breakpoints.max.sm]: {
        maxWidth: pxToRem(288),
      },
    },
  },
  searchBox: {
    backgroundColor: theme.palette.neutralWhite,
    borderBottom: `${pxToRem(1)} solid ${theme.palette.themePrimary}`,
    fontWeight: 400,
  },
  accentError: {
    borderColor: theme.palette.accentError,
  },
});
